<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#"> <img alt="Control T" src="../assets/logo.png" width="80" height="80"> </a>
        </li>
        <li class="nav-item">
          <Slide class="nav-link">
            <a id="home" href="#"><span>Inicio</span></a>
            <a href="#"><i class="fa fa-key"/> <span>Paso PC</span></a>
            <a href="#"><i class="fa fa-credit-card"/> <span>Sucesos</span></a>
            <a href="#"><i class="fa fa-question-circle"/> <span>Siniestros</span></a>
            <a href="#" @click="logout"><i class="fa fa-key"/> <span>Salir</span></a>
          </Slide>
        </li>
      </ul>
        <a class="navbar-brand" href="#"><b>Usuario conectado:</b> {{userInfo.name}} - {{userInfo.profileName}} <!--<b>Empresa:</b> {{userInfo.businessName}}--></a>
    </nav>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
export default {
  data(){
    return{
      userInfo: {
        email:''
      }
    }
  },
  components:{ Slide },
  methods: {
  logout: function () {
    this.$session.destroy()
    this.$router.push('/')
  }
},
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/')
    }
  },
  created(){
    if(this.$session.get("login-storage")){
      this.userInfo = this.$session.get("login-storage");
    }
  }
}
</script>
<style scope>
.navbar-brand {
  font-size: 0.9rem !important;
}
.bm-burger-button {
    top: 50px;
    height: 20px;
    width: 27px;
    margin: 5px;
    left: 110px !important;
}
.navbar-icon-top .navbar-nav .nav-link > .fa {
  position: relative;
  width: 36px;
  font-size: 24px;
}

.navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
  font-size: 0.75rem;
  position: absolute;
  right: 0;
  font-family: sans-serif;
}

.navbar-icon-top .navbar-nav .nav-link > .fa {
  top: 3px;
  line-height: 12px;
}

.navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
  top: -10px;
}

@media (min-width: 576px) {
  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 70px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa {
    display: block;
    width: 48px;
    margin: 2px auto 4px auto;
    top: 0;
    line-height: 24px;
  }

  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa > .badge {
    top: -7px;
  }
}

@media (min-width: 768px) {
  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 70px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa {
    display: block;
    width: 48px;
    margin: 2px auto 4px auto;
    top: 0;
    line-height: 24px;
  }

  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa > .badge {
    top: -7px;
  }
}

@media (min-width: 992px) {
  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 70px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa {
    display: block;
    width: 48px;
    margin: 2px auto 4px auto;
    top: 0;
    line-height: 24px;
  }

  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa > .badge {
    top: -7px;
  }
}

@media (min-width: 1200px) {
  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 70px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa {
    display: block;
    width: 48px;
    margin: 2px auto 4px auto;
    top: 0;
    line-height: 24px;
  }

  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa > .badge {
    top: -7px;
  }
  #nav {
    padding: 0px !important;
}
.bg-dark {
    background-color: #0B0045 !important;
}
}

</style>

